<script setup lang="ts">
  import { useLoadingBar } from 'naive-ui'

  const loadingBar = useLoadingBar()
  const router = useRouter()

  const removeBefore = router.beforeEach(() => {
    loadingBar.start()
  })

  const removeAfter = router.afterEach(() => {
    loadingBar.finish()
  })

  const removeError = router.onError(() => {
    loadingBar.error()
  })

  onBeforeUnmount(() => {
    removeBefore()
    removeAfter()
    removeError()
  })
</script>

<template></template>
